<div>
    <form [formGroup]="modalArenaForm" class="pt-4">
        <div class="w-[800px] grid grid-cols-2 gap-4">
            <div class="w-full">
              <sigecom-new-dropdown
                formControlName="competitionLocal"
                label="Local De Competição"
                [options]="competitonsLocal"
                optionIdentify="areNrId"
                optionLabel="areTxNome"
                [required]="true"
                (ngModelChange)="getSpaces($event)"
              />
            </div>
            <div class="w-full">
              <sigecom-new-dropdown
                formControlName="space"
                [options]="spaces"
                optionIdentify="epcNrId"
                optionLabel="epcTxNome"
                label="Espaço"
                #space
                [required]="true"
              />
            </div>
            <div class="w-full">
              <sigecom-date-time-picker label="Dia do confronto" [type]="DateTimeEnum.DATE" formControlName="competitonDate"
                [required]="true" sizeIcon="lg" />
            </div>
            <div class="w-full">
              <sigecom-date-time-picker label="Horário" [type]="DateTimeEnum.TIME" formControlName="competitonHour"
              [required]="true" sizeIcon="lg" />
            </div>
          </div>
          <div class="flex justify-end mt-2">
            <sigecom-button 
            type="info"
            [outlined]="true"
            icon="plus" 
            class=" pt-2 pb-2"
            title="Adicionar"
            [disabled]="!modalArenaForm.valid"
            (buttonClicked)="OnsubmitModalArenaForm()"
            >
            </sigecom-button>
        </div>
    </form>
</div>